import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFormOctagon"><Path d="M16.4346 2.29297L21.707 7.56543L22 7.85742V16.1426L21.707 16.4346L16.4346 21.707L16.1426 22H7.85742L7.56543 21.707L2.29297 16.4346L2 16.1426V7.85742L2.29297 7.56543L7.56543 2.29297L7.85742 2H16.1426L16.4346 2.29297Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormOctagon;
